// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"PeugcfoztWudXDWcYzJe","spinner":"ZRmJi_GUNfnV21kb11ah"};